import { AltraParte } from "src/app/common/models/altraparte";
import { Parte } from "src/app/common/models/parte";
import { TipoPersona } from "src/app/common/models/tipologiche/tipo-persona";
import { ElaborationDocumentFilterEntity } from "src/app/document-management/models/elaboration-doc-filter";
import { extractParteEntityFromSearch } from "./parti-utils";

export function isAltraparteAssociated(option: {isAssociable:boolean,isAssociated:boolean, hasDetailsAnagrafica: boolean, option: AltraParte }, altreparti: AltraParte[]){
    if(altreparti.length > 0){
      let filtred = altreparti.filter(altraparte => altraparte.parte.id === option.option.parte.id)
      option.isAssociated = filtred && filtred.length > 0;
    } else {
      option.isAssociated = false;
    }
}